<template>
  <div id="my-password-change " class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <div class="row mb-4">
        <div class="d-flex flex-row align-items-center">
          <i class="material-icons material-icons-title mr-2">lock</i>
          <h2 class="mt-2">Change Password</h2>
        </div>
      </div>
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="col-12">
              <p>If you need help reseting your password, we can help by sending you a link to reset it.</p>
              <p>Please complete the following steps:</p>
              <ul>
                <li>
                  Select
                  <b>Send Me A Password Reset Link</b>
                </li>
                <li>Check your inbox for a password reset email</li>
                <li>Click on the URL included inside the email and follow the instructions on screen</li>
              </ul>
              <div class="alert alert-success" v-if="passwordSent">
                <strong>Success!</strong> We have sent you an email with further instructions.
              </div>
              <div class="alert alert-danger" v-if="errorFound">
                <strong>Whoops!</strong> There was a problem processing your request.
              </div>
              <form @submit.prevent="requestPasswordReset">
                <div class="form-group">
                  <div id="auth-messages" class="auth-messages"></div>
                </div>
                <button
                  id="sendButton"
                  type="submit"
                  class="btn btn-primary"
                >Send Me A Password Reset Link</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import storage from "store";
import router from "../router";
export default {
  name: "MyPasswordChange",

  components: {
    UserMenu
  },

  data() {
    return {
      user() {
        return this.$store.getters.getUser;
      },
      passwordSent: false,
      errorFound: false,
      loading: false
    };
  },

  methods: {
    requestPasswordReset: function() {
      UserService.requestPasswordResetLoggedIn()
        .then(() => {
          this.passwordSent = true;
          this.errorFound = false;
        })
        .catch(() => {
          this.errorFound = true;
          this.passwordSent = false;
        })
        .finally(() => {});
    }
  }
};
</script>

<style scoped>
.auth-messages {
  display: none;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
